module.exports = __webpack_public_path__ + "toGroom-we-p-g.4b8ed512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-p-g.jpg
// module id = kV4y
// module chunks = 0